import React, { useState } from "react";
import {
  Form,
  Input,
  Row,
  Col,
  Divider,
  DatePicker,
  Button,
  notification,
  Upload,
  Alert,
  Card,
} from "antd";
import {
  MinusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
  SelectOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import AppService from "services/AppService";
import { useEffect } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import { FaLinkedinIn } from "react-icons/fa";
import {
  showAuthMessage,
  hideAuthMessage,
  getProfile,
  setLogo,
  setLogoActive,
} from "redux/actions/Auth";
import Flex from "components/shared-components/Flex";
import { API_BASE_URL } from "configs/AppConfig";
import EducationAddFields from "../jobrole/components/EducationAddFields";
import ExperienceAddFields from "../jobrole/components/ExperienceAddFields";
import { useHistory } from "react-router-dom";
import ReactQuill from "react-quill";

function EditBasic(props) {
  const { message, showAuthMessage, hideAuthMessage, showMessage, getProfile } =
    props;
  const [filelist, setFilelist] = useState([]);
  const [filelist2, setFilelist2] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { id } = useParams();
  const [isChangeEmail, setIsChangeEmail] = useState(false);
  const [emailLoading, setEmailLoading] = useState(false);
  const history = useHistory();

  const options = {
    onRemove: (file) => {
      const index = filelist.indexOf(file);
      const newFileList = filelist.slice();
      newFileList.splice(index, 1);
      setFilelist(newFileList);
    },
    beforeUpload: (file) => {
      setFilelist([file]);
      return false;
    },
  };
  const options2 = {
    // onRemove: file => {
    //     console.log(filelist)
    //     const index = filelist.indexOf(file)
    //     const newFileList = filelist.slice()
    //     newFileList.splice(index, 1)
    //     console.log(newFileList)
    //     setFilelist(newFileList)
    // },
    // previewFile:(file)=>{
    //    console.log(file)
    // },
    beforeUpload: async (file) => {
      // let src = await new Promise(resolve => {
      //     const reader = new FileReader();
      //     reader.readAsDataURL(file.originFileObj)
      //     reader.onload = () => resolve(reader.result);
      // })

      return false;
    },
    onChange: async ({ fileList: newFileList }) => {
      // console.log(newFileList)
      const temp =
        newFileList.length - 1 >= 0
          ? [newFileList[newFileList.length - 1]]
          : [];

      let file = newFileList[newFileList.length - 1];
      // console.log(file)
      if (file) {
        let src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj);
          reader.onload = () => resolve(reader.result);
        });
        const image = new Image();

        image.src = src;
        // console.log(image,src)
        // console.log(image.width,image.height)
        image.onload = function () {
          if (false) {
            showAuthMessage("Image must be square.");
          } else {
            setFilelist2(temp);
          }
        };
      } else {
        setFilelist2(temp);
      }
    },

    onPreview: async (file) => {
      let src = file.url;
      if (!src) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj);
          reader.onload = () => resolve(reader.result);
        });
      }
      const image = new Image();
      image.src = src;
      const imgWindow = window.open(src);
      imgWindow.document.write(image.outerHTML);
    },
  };
  const handleFinish = (values) => {
    setLoading(true);

    const formdata = new FormData();
    formdata.append("coverLetter", values?.coverLetter ? values?.coverLetter : "");
    AppService.updateProfile({data: formdata, type:'coverLetter'})
      .then((resp) => {
        notification.success({
          message: "Profile updated successfully.",
        });
        getProfile();
        fetchProfile();
        setLoading(false);
      })
      .catch((e) => {
        showAuthMessage(e.response.data);
        setLoading(false);
      });
  };
  // function disabledDate(current) {
  //     // Can not select days before today and today
  //     return current && current.valueOf() > moment("01:12:2002");
  //   }
  const fetchProfile = () => {
    AppService.fetchProfile()
      .then((resp) => {
        // console.log(resp)
        const {
          birthDate,
          education,
          experienceDetails,
          resume,
          profileImg,
          ...rest
        } = resp;
        resume &&
          setFilelist([
            {
              uid: "-1",
              name: `${resume}`,
              status: "done",
            },
          ]);
        profileImg &&
          setFilelist2([
            {
              uid: "-1",
              name: `${profileImg}`,
              status: "done",
              url: `${API_BASE_URL}/image/profile/${profileImg}`,
            },
          ]);
        form.setFieldsValue({
          ...rest,
          birthDate: moment(birthDate),
          education: education.map((e) => {
            return {
              ...e,
              joiningDate: moment(e.joiningDate),
              passoutDate: moment(e.passoutDate),
            };
          }),
          experienceDetails: experienceDetails.map((e) => {
            return {
              ...e,
              joiningDate: moment(e.joiningDate),
              relievingDate: moment(e.relievingDate),
            };
          }),
        });
      })
      .catch((e) =>
        notification.error({
          message: "Oops! Unable to fetch Profile. ",
        })
      );
  };

  useEffect(() => {
    props.setLogo("/img/logo.png");
    props.setLogoActive(true);
    fetchProfile();
  }, []);

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => {
        hideAuthMessage();
      }, 3000);
    }
  });
  return (
    <div className="main">
      <div className="container">
        <Row>
          <Col span={24}>
            <Button
              style={{
                backgroundColor: "#1677ff",
                color: "#fff",
                marginBottom: "20px",
              }}
              icon={<SelectOutlined className="mb-3" size={20} />}
              onClick={() => history.push("/app/dashboard")}
            >
              Go Back
            </Button>
          </Col>
        </Row>
        <Card style={{ padding: "20px 2%" }}>
          <div className="settings-page-heading">
            <h1>Cover Letter</h1>
          </div>

          <Divider></Divider>
          <Form
            form={form}
            onFinish={handleFinish}
            layout="vertical"
            className="mt-5"
          >
            <Row gutter={8}>
              <Col md={24} sm={24} xs={24}>
                <Form.Item
                  name="coverLetter"
                  initialValue=""
                  label="Cover letter"
                  rules={[
                    {
                      required: true,
                      message: "Cover letter must be minimum 50 characters.",
                    },
                    {
                      pattern: "^.{50,}",
                      message: "Cover letter must be minimum 50 characters.",
                    },
                  ]}
                >
                  <ReactQuill theme="snow" />
                  {/* <Input.TextArea maxLength={500} showCount></Input.TextArea> */}
                </Form.Item>
              </Col>
            </Row>
            <Button type="primary" htmlType="submit" loading={loading}>
              Update
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  );
}
const mapStateToProps = ({ auth }) => {
  const { message, showMessage } = auth;
  return { message, showMessage };
};
const mapDispatchToProps = {
  showAuthMessage,
  hideAuthMessage,
  getProfile,
  setLogo,
  setLogoActive,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditBasic);
